/**
 * Rutas del Pricer Datec (sin el prefijo de empresa `/:slug`, que agrega el router).
 * El editor nuevo es LA pantalla: sirve `/pricer-datec/new` y `/pricer-datec/:id`, las mismas de siempre.
 */
export const RUTA_DEL_PRICER_NUEVA = '/pricer-datec/new';

export function rutaDeLaCotizacion(id: string | number, busqueda = ''): string {
  return `/pricer-datec/${id}${busqueda}`;
}
